<template>
  <v-container>
    <v-row justify="center" align="center">
      <!-- 入力不要
      <v-col cols="6">
        <v-text-field label="Template Key" v-model="template_key" disabled></v-text-field>
      </v-col>
      <v-col cols="2">
        <v-switch v-model="draft_mode" class="ma-2" label="Draft Mode"></v-switch>
      </v-col>
      <v-col cols="10">
        <v-text-field label="featuredimage" v-model="featuredimage"></v-text-field>
      </v-col>-->
      <v-col cols="12" >
        <v-row justify="center" align="end">
          <v-date-picker v-model="publish_date"></v-date-picker>
          <div class="ml-4">
            <v-text-field label="Publish Date" v-model="publish_date" disabled></v-text-field>
            <v-btn small class="mt-4" @click="caliculate_date()">Now</v-btn>
          </div>
        </v-row>
      </v-col>
      <v-col cols="12">
        <v-text-field label="Title" v-model="title"></v-text-field>
      </v-col>
      <v-col cols="12">
        <v-text-field label="Description" v-model="description"></v-text-field>
      </v-col>

      <v-col cols="6">
        <v-text-field label="Tags" v-model="tag"></v-text-field>
      </v-col>
      <v-col cols="1">
        <v-btn @click="addTag(tag)">add</v-btn>
      </v-col>
      <v-col cols="5">
        <v-select :items="authors" v-model="author" label="Author"></v-select>
      </v-col>

      <v-col cols="12">
        <v-chip
          v-for="(tag,index) in tags"
          :key="index"
          class="ma-2"
          close
          color="green"
          outlined
          @click:close="deleteTag(index)"
        >{{tag}}</v-chip>
      </v-col>

      <v-btn color="success" class="ma-4" x-large @click="download()">download</v-btn>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: "HelloWorld",

  data: () => ({
    template_key: "blog-post",
    title: "",
    publish_date: "",
    description: "",
    featuredimage: "",
    tags: [],
    tag: "",
    draft_mode: false,
    author: "CrypticToilet",
    authors: ["CrypticToilet", "Neve1074"]
  }),
  methods: {
    download() {
      const regex = /[~=+;,!$'`\\^&\\@\\{\\}\\[\]\\#\\%\\.\\*<>:\\"/\\|?*]/g;
      const file_title = this.title.replace(regex, "_");
      console.log(this.title);

      let output = `---
templateKey: ${this.template_key}
title: '${this.title}'
date: ${this.publish_date}
description: '${this.description}'
draft: ${this.draft_mode}
featuredimage: ${this.featuredimage}
author: ${this.author}
tags:\n`;
      for (let tag of this.tags) {
        output += `  - ${tag}\n`;
      }

      output += `---\n`;

      console.log(output);

      //ファイルでDL
      let blob = new Blob([output], { type: "text/plain" });
      let link = document.createElement("a");
      link.href = window.URL.createObjectURL(blob);
      link.download = `${this.publish_date}-${file_title}.md`;
      link.click();
    },
    caliculate_date() {
      const date = new Date();
      this.publish_date = date.toISOString();
    },
    addTag(tag) {
      this.tags.push(tag);
      this.tag = "";
    },
    deleteTag(index) {
      //対象の配列を消去
      this.tags.splice(index, 1);
    }
  }
};
</script>